import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getCopyrightTranslated } from './legalInfoUtils';
import { STRINGS, type Language } from './i18n';

interface FooterProps {
  language: Language;
}

export const Footer: React.FC<FooterProps> = ({ language }) => {
  const navigate = useNavigate();
  const t = STRINGS[language].footer;

  return (
    <footer
      className="footer"
      style={{
        padding: '0.85rem clamp(1.2rem, 4vw, 3rem)',
        borderTop: '1px solid var(--border)',
        background: 'var(--surface)',
        fontSize: 'var(--text-small)',
        color: 'var(--textSecondary)',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          gap: '0.6rem',
          alignItems: 'center',
        }}
      >
      <div style={{ display: 'flex', gap: '1.2rem', flexWrap: 'wrap', justifyContent: 'center' }}>
        <button
          onClick={() => navigate(`/terms/${language}`)}
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--textSecondary)',
            cursor: 'pointer',
            fontSize: 'var(--text-small)',
            fontWeight: 600,
            textDecoration: 'underline',
            padding: 0,
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--primary)')}
          onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--textSecondary)')}
        >
          {t.terms}
        </button>
        <button
          onClick={() => navigate(`/privacy/${language}`)}
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--textSecondary)',
            cursor: 'pointer',
            fontSize: 'var(--text-small)',
            fontWeight: 600,
            textDecoration: 'underline',
            padding: 0,
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--primary)')}
          onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--textSecondary)')}
        >
          {t.privacy}
        </button>
      </div>
      <div style={{ fontSize: 'var(--text-small)', color: 'var(--textTertiary)' }}>
        {getCopyrightTranslated(language)}
      </div>
      </div>
    </footer>
  );
};
